var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`accordion ${_vm.transparent ? 'accordion--transparent' : ''} ${
    _vm.dropdownOpen ? 'accordion--opened' : 'accordion--closed'
  }`},[_c('div',{class:`${_vm.canOpen ? 'accordion__header' : ''}
       ${
         _vm.dropdownOpen
           ? 'accordion__header--opened'
           : 'accordion__header--closed'
       }`,on:{"click":function($event){return _vm.toggleAccordion()}}},[(_vm.arrow)?_c('ArrowIcon',{staticClass:"accordion__header-arrow"}):_vm._e(),(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"accordion__header-slot"},[_vm._t("header")],2)],1),_c('transition',[(_vm.dropdownOpen)?_c('div',{staticClass:"accordion__body"},[_vm._t("body")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }